// FISCALIZER
export const GET_FISCALIZERS = '/fiscalizer/';
export const GET_FISCALIZER = '/fiscalizer/';
export const POST_FISCALIZER = '/fiscalizer/';
export const PUT_FISCALIZER = '/fiscalizer/';
export const DELETE_FISCALIZER = '/fiscalizer/';
